import apiAthlete from '@/api/athlete'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getAthletesStart: '[athletes] Get athletes start',
  getAthletesSuccess: '[athletes] Get athletes success',
  getAthletesFailure: '[athletes] Get athletes failure',

  getAthletesClear: '[athletes] Get athletes clear',
}

export const actionTypes = {
  getAthletes: '[athletes] Get athletes',
}

const mutations = {
  [mutationTypes.getAthletesClear](state) {
    state.total = null
    state.data = []
  },

  [mutationTypes.getAthletesStart](state) {
    state.isLoading = true
  },

  [mutationTypes.getAthletesSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }

    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getAthletesFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getAthletes](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getAthletesStart)
    return new Promise((resolve) => {
      apiAthlete
        .getArticlesList(params)
        .then((response) => {
          context.commit(mutationTypes.getAthletesSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getAthletesFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
